// extracted by mini-css-extract-plugin
module.exports = {"checkboxBox":"checkbox_checkboxBox__MxCbm","checkbox":"checkbox_checkbox__2TtGk","checkmark":"checkbox_checkmark__4nAX1"};